
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[authorUsername]",
      function () {
        return require("private-next-pages/author/[authorUsername]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[authorUsername]"])
      });
    }
  